const getStartMonth = () => {
	const dateStart = new Date();
	return new Date(dateStart.getFullYear(), dateStart.getMonth() -1, 1);
};
const getEndMonth = () => {
	const monthEnd = new Date();
	return new Date(monthEnd.getFullYear(), monthEnd.getMonth(), 0);
};

function monthCut() {
    var arre = [];
    arre.push(getStartMonth().toISOString(), getEndMonth().toISOString())
    return arre;
}

  
export default monthCut;